import { notificationTemplateGet, notificationTemplateCRUDApi, notificationTemplateHistoryApi, notificationTemplateScheduleApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getMarketingCampaign = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(notificationTemplateGet + `${query || ""}`, config);

    return response;
};

export const postTemplate = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(notificationTemplateCRUDApi, data, config);
    return response;
};

export const patchTemplate = async ({ data, id }) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(notificationTemplateCRUDApi + id + "/", data, config);
    return response;
};

export const deleteTemplateItemOp = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.delete(notificationTemplateCRUDApi + id + "/", config);

    return response;
};


export const getMarketingTemplateCampaignDetails = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(notificationTemplateHistoryApi + `${query || ""}`, config);

    return response;
};

export const startTemplatePost = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(notificationTemplateHistoryApi + "/", data, config);

    return response;
};

export const scheduleTemplateCampaign = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(notificationTemplateScheduleApi, data, config);

    return response;
};
